export default __webpack_public_path__ + "static/media/Rectangle 41.b68528f9.svg";